import * as actionTypes from './actionTypes'
import * as API from 'Front/api/billing'

//-- Bill Category List
export const billCategoryListRequest = () => ({
    type: actionTypes.GET_BILL_CATEGORY_LIST_REQUEST
})
export const billCategoryListSuccess = (response) => ({
    type: actionTypes.GET_BILL_CATEGORY_LIST_SUCCESS,
    payload: {
        response,
    }
})
export const billCategoryListError = (error) => ({
    type: actionTypes.GET_BILL_CATEGORY_LIST_ERROR,
    payload: {
        error
    }
})

//-- Bill Sub Category List

export const billSubCategoryListRequest = () => ({
    type: actionTypes.GET_BILL_SUB_CATEGORY_LIST_REQUEST
})
export const billSubCategoryListSuccess = (response) => ({
    type: actionTypes.GET_BILL_SUB_CATEGORY_LIST_SUCCESS,
    payload: {
        response,
    }
})
export const billSubCategoryListError = (error) => ({
    type: actionTypes.GET_BILL_SUB_CATEGORY_LIST_ERROR,
    payload: {
        error
    }
})

//-- Bill Create
export const billCreateRequest = () => ({
    type: actionTypes.BILL_CREATE_REQUEST
})
export const billCreateSuccess = (response) => ({
    type: actionTypes.BILL_CREATE_SUCCESS,
    payload: {
        response,
    }
})
export const billCreateError = (error) => ({
    type: actionTypes.BILL_CREATE_ERROR,
    payload: {
        error
    }
})


export const billCategoryListAction = (data) => {
    return dispatch => {
        dispatch(billCategoryListRequest())

        //return API.patientList(data)
        return API.categoryList(data)
            .then(response => {
                dispatch(billCategoryListSuccess(response.data))
            })
            .catch(error => {
                dispatch(billCategoryListError(error.response !== undefined ? error.response.data : "Internet Connection Error"))
            })
    }
}

export const billSubCategoryListAction = (catId) => {
    return dispatch => {
        dispatch(billSubCategoryListRequest())

        //return API.patientList(data)
        return API.serviceList({})
            .then(response => {
                dispatch(billSubCategoryListSuccess(response.data))
            })
            .catch(error => {
                dispatch(billSubCategoryListError(error.response !== undefined ? error.response.data : "Internet Connection Error"))
            })
    }
}

export const createBillAction = (data) => {
    return (dispatch) => {
        dispatch(billCreateRequest());
        let formData = new FormData();
        formData.append('patientId', data.patientId);
        formData.append("totalAmount", data.totalAmount ? data.totalAmount : 0);
        formData.append("totalPaidAmount", data.totalPaidAmount ? data.totalPaidAmount : 0);
        formData.append("installmentAmount", data.installmentAmount ? data.installmentAmount : 0);
        formData.append("totalDiscountAmount", data.totalDiscountAmount ? data.totalDiscountAmount : 0);
        formData.append("totalRemainingAmount", data.totalRemainingAmount ? data.totalRemainingAmount : 0);
        formData.append("services", JSON.stringify(data.services ? data.services : []));
        formData.append("paymentMode", data.paymentMode)
        return API.createBill(formData)
            .then((response) => {
                dispatch(billCreateSuccess(response.data));
            })
            .catch((error) => {
                dispatch(
                    billCreateError(
                        error.response !== undefined ?
                            error.response.data :
                            "Internet Connection Error"
                    )
                );
            });
    };
};

export const billUpdateRequest = () => ({
    type: actionTypes.BILL_UPDATE_REQUEST
})
export const billUpdateSuccess = (response) => ({
    type: actionTypes.BILL_UPDATE_SUCCESS,
    payload: {
        response,
    }
})
export const billUpdateError = (error) => ({
    type: actionTypes.BILL_UPDATE_ERROR,
    payload: {
        error
    }
})

export const updateBillAction = (data) => {
    return (dispatch) => {
        dispatch(billUpdateRequest());
        let formData = new FormData();
        formData.append('id', data.id);
        formData.append("totalAmount", data.totalAmount ? data.totalAmount : 0);
        formData.append("totalPaidAmount", data.totalPaidAmount ? data.totalPaidAmount : 0);
        formData.append("installmentAmount", data.installmentAmount ? data.installmentAmount : 0);
        formData.append("totalDiscountAmount", data.totalDiscountAmount ? data.totalDiscountAmount : 0);
        formData.append("totalRemainingAmount", data.totalRemainingAmount ? data.totalRemainingAmount : 0);
        formData.append("services", JSON.stringify(data.services ? data.services : []));
        formData.append("paymentMode", data.paymentMode)
        return API.updateBill(formData)
            .then((response) => {
                dispatch(billUpdateSuccess(response.data));
            })
            .catch((error) => {
                dispatch(
                    billUpdateError(
                        error.response !== undefined ?
                            error.response.data :
                            "Internet Connection Error"
                    )
                );
            });
    };
}

export const billListRequest = () => ({
    type: actionTypes.BILL_LIST_REQUEST
})
export const billListSuccess = (response) => ({
    type: actionTypes.BILL_LIST_SUCCESS,
    payload: {
        response,
    }
})
export const billListError = (error) => ({
    type: actionTypes.BILL_LIST_ERROR,
    payload: {
        error
    }
})

export const billListAction = (data) => {
    return (dispatch) => {
        dispatch(billListRequest());
        return API.billingList(data)
            .then((response) => {
                dispatch(billListSuccess(response.data));
            })
            .catch((error) => {
                dispatch(
                    billListError(
                        error.response !== undefined ?
                            error.response.data :
                            "Internet Connection Error"
                    )
                );
            });
    };
}